import api from '../../../api'

export default {
  getWebhookList(context, queryParams) {
    const organizationId = queryParams.organizationId
    return api.webhooks.getAll({ ...queryParams, organizationId })
  },

  createWebhook(context, data) {
    const organizationId = data.organizationId
    return api.webhooks.create({ data, organizationId })
  },

  updateWebhook(context, { webhookId, data }) {
    const organizationId = data.organizationId
    return api.webhooks.update({ data, webhookId, organizationId })
  },

  deleteWebhook(context, { webhookId, organizationId }) {
    return api.webhooks.remove({ webhookId, organizationId })
  },

  getWebhookLogs(context, { webhookId, limit, skip, organizationId }) {
    return api.webhooks.getLogs({ webhookId, organizationId, limit, skip })
  },
}
